import { Bell, LogOut, Menu, Search } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Header = ({ onMenuClick }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const trimmed = query.trim();
    if (!trimmed) return;
    navigate(`/trades?symbol=${encodeURIComponent(trimmed.toUpperCase())}`);
  };

  return (
    <header className="fixed top-0 right-0 left-0 lg:left-64 h-16 bg-slate-900/80 backdrop-blur-md border-b border-slate-800 z-30 transition-all duration-300">
      <div className="h-full px-4 lg:px-8 flex items-center justify-between">
        
        {/* Left: Mobile Menu & Search */}
        <div className="flex items-center gap-4">
          <button 
            onClick={onMenuClick}
            className="lg:hidden p-2 -ml-2 text-slate-400 hover:text-white rounded-lg hover:bg-slate-800 transition-colors"
          >
            <Menu size={24} />
          </button>
          
          <form
            onSubmit={handleSearchSubmit}
            className="hidden md:flex items-center gap-2 px-3 py-1.5 bg-slate-800/50 rounded-lg border border-slate-700/50 focus-within:border-emerald-500/50 focus-within:bg-slate-800 transition-all w-64"
          >
            <Search size={16} className="text-slate-500" />
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search trades, tickers..."
              className="bg-transparent border-none outline-none text-sm text-slate-200 w-full placeholder:text-slate-500"
            />
          </form>
        </div>

        {/* Right: Actions */}
        <div className="flex items-center gap-3 lg:gap-6">
          <button className="relative p-2 text-slate-400 hover:text-white transition-colors rounded-lg hover:bg-slate-800">
            <Bell size={20} />
            <span className="absolute top-2 right-2 w-2 h-2 bg-emerald-500 rounded-full border-2 border-slate-900"></span>
          </button>
          
          <div className="h-6 w-px bg-slate-800 hidden sm:block"></div>

          <button 
            onClick={logout}
            className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-slate-400 hover:text-red-400 transition-colors rounded-lg hover:bg-red-500/10"
          >
            <LogOut size={18} />
            <span className="hidden sm:inline">Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
